import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import DevicesOtherOutlinedIcon from "@mui/icons-material/DevicesOtherOutlined";

// The app's pages, in sidebar order. `paths` are every URL that counts as the
// page, so the item stays highlighted on its aliases and sub-routes.
export const NAV_ITEMS = [
  { label: "Dashboard", to: "/dashboard", paths: ["/dashboard"], Icon: SpaceDashboardOutlinedIcon },
  {
    label: "Device Schedule",
    to: "/device-schedule",
    paths: ["/device-schedule", "/deviceschedule"],
    Icon: EventNoteOutlinedIcon,
  },
  { label: "Reports", to: "/reports", paths: ["/reports"], Icon: AssessmentOutlinedIcon },
  {
    label: "Store Analytics",
    to: "/store-analytics",
    paths: ["/store-analytics"],
    Icon: InsightsOutlinedIcon,
  },
  // /device-master, /users and /store-master are admin only, so their items
  // are too.
  {
    label: "Device Master",
    to: "/device-master",
    paths: ["/device-master"],
    Icon: DevicesOtherOutlinedIcon,
    adminOnly: true,
  },
  { label: "Users", to: "/users", paths: ["/users"], Icon: GroupOutlinedIcon, adminOnly: true },
  {
    label: "Store Master",
    to: "/store-master",
    paths: ["/store-master", "/store-regions"],
    Icon: MapOutlinedIcon,
    adminOnly: true,
  },
];

// Whether `pathname` is the page `item` describes.
export const isPageActive = (item, pathname) =>
  item.paths.some((path) => pathname.startsWith(path));

// The page `pathname` belongs to, for the header's title; null off the list.
export const pageFor = (pathname) => NAV_ITEMS.find((item) => isPageActive(item, pathname)) ?? null;
